import {
  Box,
  Container,
  Text,
  Anchor,
  TextInput,
  Button,
  Divider,
} from "@mantine/core";
import * as Icons from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { hotelData } from "../../config/getHotel";

const footerColumns = [
  {
    links: [
      { label: "About Us", path: "/about" },
      { label: "Rooms & Suites", path: "/rooms" }, 
      { label: "Amenities", path: "/amenities" },
    ],
  },
  {
    links: [
      // { label: "Events & Weddings", path: "/events" },
       { label: "Menu", path: "/Menu" },
      { label: "Gallery", path: "/gallery" },
      { label: "Special Offers", path: "/offers" },
    
    ],
  },
  {
    links: [
    //  { label: "Careers", path: "/careers" },
      { label: "Location & Directions", path: "/contactMap" },
      { label: "Contact Us", path: "/contact" },
    ],
  },
];

const styles = {
  top: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 40,
  },
  column: {
    minWidth: 180,
  },
  newsletter: {
    minWidth: 260,
  },
  newsletterInput: {
    display: "flex",
    marginBottom: 25,
  },
  social: {
    display: "flex",
    gap: 16,
  },
  bottom: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 20,
  },
  bottomLinks: {
    display: "flex",
    gap: 10,
    flexWrap: "wrap",
  },
};

export default function Footer() {
  const navigate = useNavigate();

  const social = hotelData.social;


  const hotelName = hotelData.name;
  const themeColor = hotelData.themeColor || "#C9A14A";
  const instagram = social.instagram;
  const facebook = social.facebook;
  const youtube = social.youtube;
  const linkedin = social.linkedin;
  const twitter = social.twitter;

  return (
    <Box style={{ background: "#2b2b2b", padding: "60px 0", color: "white" }}>
      <Container size="lg">

        {/* TOP SECTION */}
        <Box style={styles.top}>
          {footerColumns.map((column, index) => (
            <Box key={index} style={styles.column}>
              {column.links.map((link) => (
                <Text key={link.label} mb={12}>
                  <Anchor
                    style={{
                      color: "inherit",
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                    onClick={() => navigate(link.path)}
                  >
                    {link.label}
                  </Anchor>
                </Text>
              ))}
            </Box>
          ))}

          {/* NEWSLETTER */}
          <Box style={styles.newsletter}>
            <Text fw={500} mb={10}>
              Subscribe to Newsletter
            </Text>

            <Box style={styles.newsletterInput}>
              <TextInput
                placeholder="Enter your email id"
                radius={0}
                style={{ flex: 1 }}
              />
              <Button radius={0} style={{ background: themeColor }}>
                Subscribe
              </Button>
            </Box>

            <Text fw={500} mb={10}>
              Follow Us
            </Text>

            <Box style={styles.social}>
              {instagram && (
                <Anchor href={instagram} target="_blank">
                  <Icons.IconBrandInstagram size={22} color="white" />
                </Anchor>
              )}
              {twitter && (
                <Anchor href={twitter} target="_blank">
                  <Icons.IconBrandX size={22} color="white" />
                </Anchor>
              )}
              {youtube && (
                <Anchor href={youtube} target="_blank">
                  <Icons.IconBrandYoutube size={22} color="white" />
                </Anchor>
              )}
              {facebook && (
                <Anchor href={facebook} target="_blank">
                  <Icons.IconBrandFacebook size={22} color="white" />
                </Anchor>
              )}
              {linkedin && (
                <Anchor href={linkedin} target="_blank">
                  <Icons.IconBrandLinkedin size={22} color="white" />
                </Anchor>
              )}
            </Box>
          </Box>
        </Box>

        <Divider my="xl" color="gray" />

        {/* BOTTOM */}
        <Box style={styles.bottom}>
          <Text color="dimmed" size="sm">
            © {new Date().getFullYear()} {hotelName}. All rights reserved.
          </Text>

          <Box style={styles.bottomLinks}>
            <Anchor
              style={{ color: "#aaa", cursor: "pointer" }}
              onClick={() => navigate("/privacy-policy")}
            >
              Privacy Policy
            </Anchor>

            <Text color="dimmed">|</Text>

            <Anchor
              style={{ color: "#aaa", cursor: "pointer" }}
              onClick={() => navigate("/legal")}
            >
              Legal
            </Anchor>

            <Text color="dimmed">|</Text>

            <Anchor
              style={{ color: "#aaa", cursor: "pointer" }}
              onClick={() => navigate("/terms-and-conditions")}
            >
              Terms & Conditions
            </Anchor>

         
          </Box>
        </Box>
      </Container>
    </Box>
  );
}